export const VitaminBoostDailyTrialFixture = {
  id: 4,
  title: 'Vitamin Lens Trial',
  handle: 'trial-vitamin-lenses',
  description:
    'Help your eyes relax with our ultra-comfortable vitamin lenses.',
  productVariants: [
    {
      id: 151,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-0-50',
      label: null,
      description: null,
      assets: [
        {
          asset: {
            id: 2,
            path: '/images/products/vitamin-lens/vitamin-blister-pack.svg',
          },
        },
      ],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -0.50',
            value: '-0.50',
            id: 1,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 601,
          region: 'US',
          sku: 'WALVITFIRST-0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 602,
          region: 'UK',
          sku: 'WALVITFIRST-0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 603,
          region: 'SE',
          sku: 'WALVITFIRST-0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 604,
          region: 'EU',
          sku: 'WALVITFIRST-0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 152,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-0-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -0.75',
            value: '-0.75',
            id: 2,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 605,
          region: 'US',
          sku: 'WALVITFIRST-0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 606,
          region: 'UK',
          sku: 'WALVITFIRST-0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 607,
          region: 'SE',
          sku: 'WALVITFIRST-0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 608,
          region: 'EU',
          sku: 'WALVITFIRST-0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 153,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-1-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -1.00',
            value: '-1.00',
            id: 3,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 609,
          region: 'US',
          sku: 'WALVITFIRST-1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 610,
          region: 'UK',
          sku: 'WALVITFIRST-1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 611,
          region: 'SE',
          sku: 'WALVITFIRST-1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 612,
          region: 'EU',
          sku: 'WALVITFIRST-1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 154,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-1-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -1.25',
            value: '-1.25',
            id: 4,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 613,
          region: 'US',
          sku: 'WALVITFIRST-1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 614,
          region: 'UK',
          sku: 'WALVITFIRST-1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 615,
          region: 'SE',
          sku: 'WALVITFIRST-1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 616,
          region: 'EU',
          sku: 'WALVITFIRST-1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 155,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-1-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -1.50',
            value: '-1.50',
            id: 5,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 617,
          region: 'US',
          sku: 'WALVITFIRST-1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 618,
          region: 'UK',
          sku: 'WALVITFIRST-1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 619,
          region: 'SE',
          sku: 'WALVITFIRST-1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 620,
          region: 'EU',
          sku: 'WALVITFIRST-1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 156,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-1-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -1.75',
            value: '-1.75',
            id: 6,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 621,
          region: 'US',
          sku: 'WALVITFIRST-1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 622,
          region: 'UK',
          sku: 'WALVITFIRST-1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 623,
          region: 'SE',
          sku: 'WALVITFIRST-1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 624,
          region: 'EU',
          sku: 'WALVITFIRST-1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 157,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-2-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -2.00',
            value: '-2.00',
            id: 7,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 625,
          region: 'US',
          sku: 'WALVITFIRST-2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 626,
          region: 'UK',
          sku: 'WALVITFIRST-2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 627,
          region: 'SE',
          sku: 'WALVITFIRST-2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 628,
          region: 'EU',
          sku: 'WALVITFIRST-2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 158,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-2-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -2.25',
            value: '-2.25',
            id: 8,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 629,
          region: 'US',
          sku: 'WALVITFIRST-2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 630,
          region: 'UK',
          sku: 'WALVITFIRST-2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 631,
          region: 'SE',
          sku: 'WALVITFIRST-2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 632,
          region: 'EU',
          sku: 'WALVITFIRST-2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 159,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-2-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -2.50',
            value: '-2.50',
            id: 9,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 633,
          region: 'US',
          sku: 'WALVITFIRST-2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 634,
          region: 'UK',
          sku: 'WALVITFIRST-2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 635,
          region: 'SE',
          sku: 'WALVITFIRST-2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 636,
          region: 'EU',
          sku: 'WALVITFIRST-2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 160,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-2-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -2.75',
            value: '-2.75',
            id: 10,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 637,
          region: 'US',
          sku: 'WALVITFIRST-2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 638,
          region: 'UK',
          sku: 'WALVITFIRST-2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 639,
          region: 'SE',
          sku: 'WALVITFIRST-2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 640,
          region: 'EU',
          sku: 'WALVITFIRST-2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 161,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-3-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -3.00',
            value: '-3.00',
            id: 11,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 641,
          region: 'US',
          sku: 'WALVITFIRST-3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 642,
          region: 'UK',
          sku: 'WALVITFIRST-3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 643,
          region: 'SE',
          sku: 'WALVITFIRST-3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 644,
          region: 'EU',
          sku: 'WALVITFIRST-3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 162,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-3-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -3.25',
            value: '-3.25',
            id: 12,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 645,
          region: 'US',
          sku: 'WALVITFIRST-3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 646,
          region: 'UK',
          sku: 'WALVITFIRST-3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 647,
          region: 'SE',
          sku: 'WALVITFIRST-3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 648,
          region: 'EU',
          sku: 'WALVITFIRST-3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 163,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-3-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -3.50',
            value: '-3.50',
            id: 13,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 649,
          region: 'US',
          sku: 'WALVITFIRST-3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 650,
          region: 'UK',
          sku: 'WALVITFIRST-3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 651,
          region: 'SE',
          sku: 'WALVITFIRST-3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 652,
          region: 'EU',
          sku: 'WALVITFIRST-3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 164,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-3-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -3.75',
            value: '-3.75',
            id: 14,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 653,
          region: 'US',
          sku: 'WALVITFIRST-3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 654,
          region: 'UK',
          sku: 'WALVITFIRST-3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 655,
          region: 'SE',
          sku: 'WALVITFIRST-3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 656,
          region: 'EU',
          sku: 'WALVITFIRST-3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 165,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-4-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -4.00',
            value: '-4.00',
            id: 15,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 657,
          region: 'US',
          sku: 'WALVITFIRST-4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 658,
          region: 'UK',
          sku: 'WALVITFIRST-4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 659,
          region: 'SE',
          sku: 'WALVITFIRST-4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 660,
          region: 'EU',
          sku: 'WALVITFIRST-4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 166,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-4-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -4.25',
            value: '-4.25',
            id: 16,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 661,
          region: 'US',
          sku: 'WALVITFIRST-4.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 662,
          region: 'UK',
          sku: 'WALVITFIRST-4.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 663,
          region: 'SE',
          sku: 'WALVITFIRST-4.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 664,
          region: 'EU',
          sku: 'WALVITFIRST-4.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 167,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-4-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -4.50',
            value: '-4.50',
            id: 17,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 665,
          region: 'US',
          sku: 'WALVITFIRST-4.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 666,
          region: 'UK',
          sku: 'WALVITFIRST-4.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 667,
          region: 'SE',
          sku: 'WALVITFIRST-4.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 668,
          region: 'EU',
          sku: 'WALVITFIRST-4.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 168,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-4-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -4.75',
            value: '-4.75',
            id: 18,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 669,
          region: 'US',
          sku: 'WALVITFIRST-4.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 670,
          region: 'UK',
          sku: 'WALVITFIRST-4.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 671,
          region: 'SE',
          sku: 'WALVITFIRST-4.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 672,
          region: 'EU',
          sku: 'WALVITFIRST-4.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 169,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-5-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -5.00',
            value: '-5.00',
            id: 19,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 673,
          region: 'US',
          sku: 'WALVITFIRST-5.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 674,
          region: 'UK',
          sku: 'WALVITFIRST-5.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 675,
          region: 'SE',
          sku: 'WALVITFIRST-5.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 676,
          region: 'EU',
          sku: 'WALVITFIRST-5.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 170,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-5-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -5.25',
            value: '-5.25',
            id: 20,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 677,
          region: 'US',
          sku: 'WALVITFIRST-5.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 678,
          region: 'UK',
          sku: 'WALVITFIRST-5.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 679,
          region: 'SE',
          sku: 'WALVITFIRST-5.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 680,
          region: 'EU',
          sku: 'WALVITFIRST-5.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 171,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-5-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -5.50',
            value: '-5.50',
            id: 21,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 681,
          region: 'US',
          sku: 'WALVITFIRST-5.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 682,
          region: 'UK',
          sku: 'WALVITFIRST-5.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 683,
          region: 'SE',
          sku: 'WALVITFIRST-5.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 684,
          region: 'EU',
          sku: 'WALVITFIRST-5.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 172,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-5-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -5.75',
            value: '-5.75',
            id: 22,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 685,
          region: 'US',
          sku: 'WALVITFIRST-5.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 686,
          region: 'UK',
          sku: 'WALVITFIRST-5.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 687,
          region: 'SE',
          sku: 'WALVITFIRST-5.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 688,
          region: 'EU',
          sku: 'WALVITFIRST-5.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 173,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-6-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -6.00',
            value: '-6.00',
            id: 23,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 689,
          region: 'US',
          sku: 'WALVITFIRST-6.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 690,
          region: 'UK',
          sku: 'WALVITFIRST-6.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 691,
          region: 'SE',
          sku: 'WALVITFIRST-6.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 692,
          region: 'EU',
          sku: 'WALVITFIRST-6.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 174,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-6-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -6.50',
            value: '-6.50',
            id: 24,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 693,
          region: 'US',
          sku: 'WALVITFIRST-6.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 694,
          region: 'UK',
          sku: 'WALVITFIRST-6.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 695,
          region: 'SE',
          sku: 'WALVITFIRST-6.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 696,
          region: 'EU',
          sku: 'WALVITFIRST-6.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 175,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-7-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -7.00',
            value: '-7.00',
            id: 25,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 697,
          region: 'US',
          sku: 'WALVITFIRST-7.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 698,
          region: 'UK',
          sku: 'WALVITFIRST-7.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 699,
          region: 'SE',
          sku: 'WALVITFIRST-7.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 700,
          region: 'EU',
          sku: 'WALVITFIRST-7.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 176,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-7-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -7.50',
            value: '-7.50',
            id: 26,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 701,
          region: 'US',
          sku: 'WALVITFIRST-7.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 702,
          region: 'UK',
          sku: 'WALVITFIRST-7.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 703,
          region: 'SE',
          sku: 'WALVITFIRST-7.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 704,
          region: 'EU',
          sku: 'WALVITFIRST-7.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 177,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-8-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -8.00',
            value: '-8.00',
            id: 27,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 705,
          region: 'US',
          sku: 'WALVITFIRST-8.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 706,
          region: 'UK',
          sku: 'WALVITFIRST-8.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 707,
          region: 'SE',
          sku: 'WALVITFIRST-8.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 708,
          region: 'EU',
          sku: 'WALVITFIRST-8.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 178,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-8-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -8.50',
            value: '-8.50',
            id: 28,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 709,
          region: 'US',
          sku: 'WALVITFIRST-8.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 710,
          region: 'UK',
          sku: 'WALVITFIRST-8.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 711,
          region: 'SE',
          sku: 'WALVITFIRST-8.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 712,
          region: 'EU',
          sku: 'WALVITFIRST-8.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 179,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-9-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -9.00',
            value: '-9.00',
            id: 29,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 713,
          region: 'US',
          sku: 'WALVITFIRST-9.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 714,
          region: 'UK',
          sku: 'WALVITFIRST-9.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 715,
          region: 'SE',
          sku: 'WALVITFIRST-9.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 716,
          region: 'EU',
          sku: 'WALVITFIRST-9.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 180,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-9-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -9.50',
            value: '-9.50',
            id: 30,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 717,
          region: 'US',
          sku: 'WALVITFIRST-9.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 718,
          region: 'UK',
          sku: 'WALVITFIRST-9.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 719,
          region: 'SE',
          sku: 'WALVITFIRST-9.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 720,
          region: 'EU',
          sku: 'WALVITFIRST-9.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 181,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-10-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -10.00',
            value: '-10.00',
            id: 31,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 721,
          region: 'US',
          sku: 'WALVITFIRST-10.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 722,
          region: 'UK',
          sku: 'WALVITFIRST-10.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 723,
          region: 'SE',
          sku: 'WALVITFIRST-10.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 724,
          region: 'EU',
          sku: 'WALVITFIRST-10.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 182,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-10-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -10.50',
            value: '-10.50',
            id: 32,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 725,
          region: 'US',
          sku: 'WALVITFIRST-10.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 726,
          region: 'UK',
          sku: 'WALVITFIRST-10.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 727,
          region: 'SE',
          sku: 'WALVITFIRST-10.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 728,
          region: 'EU',
          sku: 'WALVITFIRST-10.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 183,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-11-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -11.00',
            value: '-11.00',
            id: 33,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 729,
          region: 'US',
          sku: 'WALVITFIRST-11.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 730,
          region: 'UK',
          sku: 'WALVITFIRST-11.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 731,
          region: 'SE',
          sku: 'WALVITFIRST-11.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 732,
          region: 'EU',
          sku: 'WALVITFIRST-11.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 184,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-11-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -11.50',
            value: '-11.50',
            id: 34,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 733,
          region: 'US',
          sku: 'WALVITFIRST-11.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 734,
          region: 'UK',
          sku: 'WALVITFIRST-11.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 735,
          region: 'SE',
          sku: 'WALVITFIRST-11.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 736,
          region: 'EU',
          sku: 'WALVITFIRST-11.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 185,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-negative-12-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -12.00',
            value: '-12.00',
            id: 35,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 737,
          region: 'US',
          sku: 'WALVITFIRST-12.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 738,
          region: 'UK',
          sku: 'WALVITFIRST-12.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 739,
          region: 'SE',
          sku: 'WALVITFIRST-12.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 740,
          region: 'EU',
          sku: 'WALVITFIRST-12.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 186,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-positive-0-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +0.50',
            value: '+0.50',
            id: 36,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 741,
          region: 'US',
          sku: 'WALVITFIRST+0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 742,
          region: 'UK',
          sku: 'WALVITFIRST+0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 743,
          region: 'SE',
          sku: 'WALVITFIRST+0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 744,
          region: 'EU',
          sku: 'WALVITFIRST+0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 187,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-positive-0-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +0.75',
            value: '+0.75',
            id: 37,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 745,
          region: 'US',
          sku: 'WALVITFIRST+0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 746,
          region: 'UK',
          sku: 'WALVITFIRST+0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 747,
          region: 'SE',
          sku: 'WALVITFIRST+0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 748,
          region: 'EU',
          sku: 'WALVITFIRST+0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 188,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-positive-1-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +1.00',
            value: '+1.00',
            id: 38,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 749,
          region: 'US',
          sku: 'WALVITFIRST+1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 750,
          region: 'UK',
          sku: 'WALVITFIRST+1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 751,
          region: 'SE',
          sku: 'WALVITFIRST+1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 752,
          region: 'EU',
          sku: 'WALVITFIRST+1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 189,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-positive-1-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +1.25',
            value: '+1.25',
            id: 39,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 753,
          region: 'US',
          sku: 'WALVITFIRST+1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 754,
          region: 'UK',
          sku: 'WALVITFIRST+1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 755,
          region: 'SE',
          sku: 'WALVITFIRST+1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 756,
          region: 'EU',
          sku: 'WALVITFIRST+1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 190,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-positive-1-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +1.50',
            value: '+1.50',
            id: 40,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 757,
          region: 'US',
          sku: 'WALVITFIRST+1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 758,
          region: 'UK',
          sku: 'WALVITFIRST+1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 759,
          region: 'SE',
          sku: 'WALVITFIRST+1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 760,
          region: 'EU',
          sku: 'WALVITFIRST+1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 191,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-positive-1-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +1.75',
            value: '+1.75',
            id: 41,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 761,
          region: 'US',
          sku: 'WALVITFIRST+1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 762,
          region: 'UK',
          sku: 'WALVITFIRST+1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 763,
          region: 'SE',
          sku: 'WALVITFIRST+1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 764,
          region: 'EU',
          sku: 'WALVITFIRST+1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 192,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-positive-2-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +2.00',
            value: '+2.00',
            id: 42,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 765,
          region: 'US',
          sku: 'WALVITFIRST+2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 766,
          region: 'UK',
          sku: 'WALVITFIRST+2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 767,
          region: 'SE',
          sku: 'WALVITFIRST+2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 768,
          region: 'EU',
          sku: 'WALVITFIRST+2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 193,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-positive-2-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +2.25',
            value: '+2.25',
            id: 43,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 769,
          region: 'US',
          sku: 'WALVITFIRST+2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 770,
          region: 'UK',
          sku: 'WALVITFIRST+2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 771,
          region: 'SE',
          sku: 'WALVITFIRST+2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 772,
          region: 'EU',
          sku: 'WALVITFIRST+2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 194,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-positive-2-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +2.50',
            value: '+2.50',
            id: 44,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 773,
          region: 'US',
          sku: 'WALVITFIRST+2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 774,
          region: 'UK',
          sku: 'WALVITFIRST+2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 775,
          region: 'SE',
          sku: 'WALVITFIRST+2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 776,
          region: 'EU',
          sku: 'WALVITFIRST+2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 195,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-positive-2-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +2.75',
            value: '+2.75',
            id: 45,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 777,
          region: 'US',
          sku: 'WALVITFIRST+2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 778,
          region: 'UK',
          sku: 'WALVITFIRST+2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 779,
          region: 'SE',
          sku: 'WALVITFIRST+2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 780,
          region: 'EU',
          sku: 'WALVITFIRST+2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 196,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-positive-3-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +3.00',
            value: '+3.00',
            id: 46,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 781,
          region: 'US',
          sku: 'WALVITFIRST+3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 782,
          region: 'UK',
          sku: 'WALVITFIRST+3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 783,
          region: 'SE',
          sku: 'WALVITFIRST+3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 784,
          region: 'EU',
          sku: 'WALVITFIRST+3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 197,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-positive-3-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +3.25',
            value: '+3.25',
            id: 47,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 785,
          region: 'US',
          sku: 'WALVITFIRST+3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 786,
          region: 'UK',
          sku: 'WALVITFIRST+3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 787,
          region: 'SE',
          sku: 'WALVITFIRST+3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 788,
          region: 'EU',
          sku: 'WALVITFIRST+3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 198,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-positive-3-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +3.50',
            value: '+3.50',
            id: 48,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 789,
          region: 'US',
          sku: 'WALVITFIRST+3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 790,
          region: 'UK',
          sku: 'WALVITFIRST+3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 791,
          region: 'SE',
          sku: 'WALVITFIRST+3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 792,
          region: 'EU',
          sku: 'WALVITFIRST+3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 199,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-positive-3-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +3.75',
            value: '+3.75',
            id: 49,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 793,
          region: 'US',
          sku: 'WALVITFIRST+3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 794,
          region: 'UK',
          sku: 'WALVITFIRST+3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 795,
          region: 'SE',
          sku: 'WALVITFIRST+3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 796,
          region: 'EU',
          sku: 'WALVITFIRST+3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 200,
      title: 'Vitamin Lens Trial',
      handle: 'trial-vitamin-lenses-positive-4-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +4.00',
            value: '+4.00',
            id: 50,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 797,
          region: 'US',
          sku: 'WALVITFIRST+4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 798,
          region: 'UK',
          sku: 'WALVITFIRST+4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 799,
          region: 'SE',
          sku: 'WALVITFIRST+4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 800,
          region: 'EU',
          sku: 'WALVITFIRST+4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
  ],
};
